import CreationWizardStepWrapper from './CreationWizardStepWrapper.vue';
import CreationWizardStepHeaderWrapper from './CreationWizardStepHeaderWrapper.vue';
import { CREATION_WIZARD_STEPS } from '@/components/CreationWizard/creation-wizard.const';
import WizardActionsFromStepMixin from './common/WizardActionsFromStepMixin';

export default {
	props: {
		wizardStep: { type: Number, validator: (v) => Object.values(CREATION_WIZARD_STEPS).includes(v) },
		previousSteps: { type: Array },
	},
	mixins: [WizardActionsFromStepMixin],
	components: { CreationWizardStepWrapper, CreationWizardStepHeaderWrapper },
	computed: {
		headerWrapperProps() {
			return { previousSteps: this.previousSteps };
		},
		headerWrapperListeners() {
			return { prevStep: this.prevStep };
		},
		isFirstStep() {
			return this.previousSteps.length === 0;
		},
	},
	methods: {
		nextStep() {
			this.$emit('next-step');
		},
		prevStep() {
			this.$emit('prev-step');
		},
		updateState({ key, value }) {
			this.$emit('update-state', { key, value });
		},
	},
};
